import http from '../common/http'

export const findAll = (param) =>{
  return http.requestPost('/role/findAll?page='+param.page+'&size='+param.size,param.form);
}
export const findUserByRoleId = (id) =>{
  return http.requestPost('/role/findUserByRoleId/'+id);
}

export const update = (param) =>{
  return http.requestPost('/role/update',param);
}
export const save = (param) =>{
  return http.requestPost('/role/save',param);
}
export const del = (id) =>{
  return http.requestPost('/role/delete/'+id,);
}


